import React, { Component } from "react";

import "./index.css";
import "./StatusPage.css";
import { Result, Button } from "antd";

import genistaLogo from "../../assets/images/logo/genista-logo.svg";

export default class StatusPage extends Component {
  onGotoLogin = () => {
    const { history } = this.props;
    history.push("/login");
  };

  render() {
    const {
      status,
      title,
      subtitle,
      showLoginButton,
    } = this.props;

    return (
      <div className="auth-wrapper login-page">
        <div className="logoImgWrapper">
          <img
            src={genistaLogo}
            alt="Genista"
            className="logoImg"
          />
        </div>
        <div
          className="auth-inner signup-success"
        >
          <Result
            status={status}
            title={title}
            subTitle={subtitle}
            extra={showLoginButton ? [
              <Button
                type="primary"
                key="console"
                onClick={this.onGotoLogin}
                className="StatusPage__GoToLoginBtn"
              >
                Go to Login
              </Button>,
            ] : []}
          />
        </div>
      </div>
    );
  }
}
